import { render, staticRenderFns } from "./customize-message-step.vue?vue&type=template&id=0aff76c2"
import script from "./customize-message-step.vue?vue&type=script&lang=js"
export * from "./customize-message-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports